<template>
  <div class="dataTables_wrapper no-footer mtable">
      <div class="datatable-header mtable-tool hui-group-dib-box">
          <seek v-if="seekDropdown" @seek="seek" class="pull-left m-r-30 mtable-tool-seek" :seekDropdown="seekDropdownProps"></seek>
          <selPage v-if="selPage" class="pull-right" :multiLanguage="multiLanguage" :selPage="selPage" @selPage="selPageFn"></selPage>
          <div class="btn-group p-0 pull-left mtable-tool-fn">
              <label class="btn btn-default showName">
                  <input type="checkbox" v-model="showName">
                  <span>{{multiLanguage.showName}}</span>
              </label>
              <button class="btn btn-default" @click="excelCallbackFn">
                   <i class="glyphicon glyphicon-save tab-he-glyphicon"></i>{{multiLanguage.downloadExcelForms}}
              </button>
          </div>
          <div class="clear"></div>
      </div>
      <div class="datatable-scroll">
          <table class="table table-bordered table-hover datatable-highlight dataTable no-footer table-striped" id="DataTables_Table_2" role="grid" aria-describedby="DataTables_Table_2_info">
              <thead>
                  <tr role="row">
                      <th v-for="(item,index) in thData">
                          <dropdown tag="li">
                            <a class="dropdown-toggle" role="button">{{multiLanguage.th.loginType.roleType[item]}}<span class="caret"></span></a>
                            <template slot="dropdown">
                                <ul class="dropdown-item">
                                    <li @click="filterFn(data,filterData[item],seekDropdown.seekStr,index)" v-for="(data,num) in filterData[item]"><a role="button">{{data}}</a></li>
                                </ul>
                            </template>
                          </dropdown>
                      </th>
                  </tr>
              </thead>
              <tbody>
                  <tr role="row" v-for="(item,index) in trData">
                      <td v-if="item.TD">
                          <span>{{item.TD.id}}</span>
                          <span v-show="showName"> - {{item.TD.name}}</span>
                      </td>
                      <td v-if="item.CL">
                          <span>{{item.CL.id}}</span>
                          <span v-show="showName"> - {{item.CL.name}}</span>
                      </td>
                      <td v-else>-</td>

                      <td v-if="item.IB && item.IB.length == 1">
                          <span>{{item.IB[0].id}}</span>
                          <span v-show="showName">-{{item.IB[0].name}}</span>
                      </td>
                      <td v-else-if="item.IB && item.IB.length>1" v-for="(obj,i) in item.IB">
                          <span>{{obj.id}}</span>
                          <span v-show="showName">-{{obj.name}}</span>
                      </td>
                      <td v-else>-</td>  

                      <td v-if="item.SL && item.SL.length == 1">
                          <span>{{item.SL[0].id}}</span>
                          <span v-show="showName">-{{item.SL[0].name}}</span>
                      </td>
                      <td v-else-if="item.SL && item.SL.length>1" v-for="(obj,i) in item.SL">
                          <span>{{obj.id}}</span>
                          <span v-show="showName">-{{obj.name}}</span>
                      </td>
                      <td v-else>-</td>
                      
                      <td v-if="item.M && item.M.length == 1">
                          <span>{{item.M[0].id}}</span>
                          <span v-show="showName">-{{item.M[0].name}}</span>
                      </td>
                      <td v-else-if="item.M && item.M.length>1" v-for="(obj,i) in item.M">
                          <span>{{obj.id}}</span>
                          <span v-show="showName">-{{obj.name}}</span>
                      </td>
                      <td v-else>-</td>

                      <td v-if="item.O && item.O.length == 1">
                          <span>{{item.O[0].id}}</span>
                          <span v-show="showName">-{{item.O[0].name}}</span>
                      </td>
                      <td v-else-if="item.O && item.O.length >1" v-for="(obj,i) in item.O">
                          <span>{{obj.id}}</span>
                          <span v-show="showName">-{{obj.name}}</span>
                      </td>
                      <td v-else>-</td>

                      <td v-if="item.R && item.R.length == 1">
                          <span>{{item.R[0].id}}</span>
                          <span v-show="showName">-{{item.R[0].name}}</span>
                      </td>
                      <td v-else-if="item.R && item.R.length >1" v-for="(obj,i) in item.R">
                          <span>{{obj.id}}</span>
                          <span v-show="showName">-{{obj.name}}</span>
                      </td>
                      <td v-else>-</td>

                      <td v-if="item.N && item.N.length == 1">
                          <span>{{item.N[0].id}}</span>
                          <span v-show="showName">-{{item.N[0].name}}</span>
                      </td>
                      <td v-else-if="item.N && item.N.length >1" v-for="(obj,i) in item.N">
                          <span>{{obj.id}}</span>
                          <span v-show="showName">-{{obj.name}}</span>
                      </td>
                      <td v-else>-</td>

                      <td v-if="item.C&& item.C.length == 1">
                          <span>{{item.C[0].id}}</span>
                          <span v-show="showName">-{{item.C[0].name}}</span>
                      </td>
                      <td v-else-if="item.C && item.C.length >1" v-for="(obj,i) in item.C">
                          <span>{{obj.id}}</span>
                          <span v-show="showName">-{{obj.name}}</span>
                      </td>
                      <td v-else>-</td>

                      <td v-if="item.UN&& item.UN.length == 1">
                          <span>{{item.UN[0].id}}</span>
                          <span v-show="showName">-{{item.UN[0].name}}</span>
                      </td>
                      <td v-else-if="item.UN && item.UN.length >1" v-for="(obj,i) in item.UN">
                          <span>{{obj.id}}</span>
                          <span v-show="showName">-{{obj.name}}</span>
                      </td>
                      <td v-else>-</td>

                  </tr>
              </tbody>
          </table>
          <noData v-if="trData.length==0" :text="multiLanguage.nodata" :fontSize="'18'"></noData>
      </div>
      <div class="datatable-footer">
            <div class="dataTables_info" id="DataTables_Table_2_info" role="status" aria-live="polite">
                {{multiLanguage.clauses}}{{multiLanguage.amount}}:&nbsp;
                {{page.pageLeng}}&nbsp;&nbsp;{{multiLanguage.present}}:&nbsp;{{page.active*selPage.limit-selPage.limit+1}}-{{Math.min(page.active*selPage.limit,page.pageLeng)}}
            </div>
            <div v-if="Math.ceil(page.pageLeng/selPage.list[selPage.active])" class="dataTables_paginate paging_simple_numbers" id="DataTables_Table_2_paginate">
                <pagination v-model="pageactive" 
                :boundary-links="true" :direction-links="true" 
                :total-page="Math.ceil(page.pageLeng/selPage.list[selPage.active])" 
                :max-size="page.pagenum" @change="callpageFn">
                </pagination>
            </div>
      </div>
  </div>
</template>
<script>
import seek from "./relationshipSeek"
import selPage from "components/selPage"
import noData from "components/noData"
import { Btn, Pagination, Dropdown} from "uiv"
import { mapMutations } from "vuex"
import { Api } from 'api/commissionEnv'
var api = new Api()
export default {
  props: {
      filterData: {
          type: Object,
          default: {}
      },
      thData: {  // 表格th数据
        type: Array,
        default: []
      },
      trData: {},  // 表格tr数据
      sort: { // 排序
        default: false
      },
      multiLanguage: {  // 翻译，也是文字型数据
        type: Object,
        default: {}
      },
      seekDropdown: {  // 搜索目标选项
        default: false
      },
      selPage: {  // 显示条目数
        default: false
      },
      page: {  // 分页
        default: false
      },
  },
  components: {
      seek,
      selPage,
      noData,
      Btn,
      Pagination,
      Dropdown
  },
  data () {
      return {
          showName: true,
          pageactive: this.page ? this.page.active : "",
          seekDropdownProps: this.seekDropdown ? this.seekDropdown : "",
      }
  },
  methods: {
    excelCallbackFn() {
        this.$emit('downLoadExcelFn',this.showName)
    },
    filterFn (data,arr,seekStr,index) {
        console.log(data);
        let code = ''
        for (let key in this.trData[0]) {
            if (
                key == 'IB' || key == 'SL' || key == 'M' 
                || key== "O" || key=="R" || "N" == key 
                || 'C' == key || 'UN' == key
            ) {
                this.trData[0][key].forEach((el,i) => {
                    if (el.id == seekStr) code = key
                })
            } else {
                if (this.trData[0][key].id == seekStr) code = key
            }
        }
           if (index <= this.thData.indexOf(code)) { 
            this.$parent.filterVal = data
            this.pageactive = 1
            if (this.page) this.$parent.page.offset = 0
            if (this.$parent.page) this.$parent.page.active = 1
            this.$emit('filterFn')
        }
    },
    seek (seekStr) {
        this.pageactive = 1
        if (this.page) this.$parent.page.offset = 0
        if (this.$parent.page) this.$parent.page.active = 1
        this.$emit("seek")
    },
    callpageFn (index) {
        this.$parent.page.active = index
        this.$parent.page.offset = this.selPage ? (this.page.active - 1) * this.selPage.list[this.selPage.active] : ""
        this.$parent.filterVal ? this.$emit('filterFn') : this.$emit("tableChange")

    },
    selPageFn (index, item) {
        this.SAVEPAGEMAXINDEX(index)
        this.$parent.selPage.active = index
        this.$parent.selPage.limit = this.selPage.list[this.selPage.active]
        this.$parent.page.offset = 0
        this.pageactive = 1
        this.$parent.page.active = 1
        this.$parent.filterVal ? this.$emit('filterFn') : this.$emit("tableChange")
    },
    ...mapMutations(["SAVEPAGEMAXINDEX"])
  }
}
</script>
<style lang="scss" scoped>
 .mtable{
        li{
            list-style: none;
        }
        li a {
            color: #333;
        }
        .seek-box{
            border: 1px solid #ddd;
        }
        .datatable-scroll{
        .table{
            .dropdown-item{
                padding: 0;
                min-height: 100px;
                max-height: 200px;
                overflow: auto;
                font-size: 13px;
                font-weight: normal;
                li {
                    position: relative;
                    margin-bottom: 1px; 
                    padding: 8px 15px;
                }
                li:hover{
                    background-color: #f5f5f5;
                    
                }
                li a {
                    display: block;
                }
            }
            thead{
            border-top: 1px solid #ddd;
            tr {
                background-color: #EBEDF7;
            }
            }
        }
        }
        .mtable-tool{
        padding: 0 20px 25px;
        border-bottom: 0;
        .mtable-tool-seek,.mtable-tool-selPage,.mtable-tool-fn {
            padding-top: 20px;
            line-height: 36px;
            .showName{
                input[type="checkbox"]{
                    margin-top: 0;
                    vertical-align: middle;
                    height: 15px;
                    width: 15px;
                }
            }
        }
        .mtable-tool-fn {
            .radius-r{
            border-top-right-radius: 3px !important;
            border-bottom-right-radius: 3px !important;
            }
        }
        }
  }
</style>




// WEBPACK FOOTER //
// relationShipTable.vue?06b09359